import React, { useMemo } from 'react'
import loadable from '@loadable/component'
import { connectPagination } from 'react-instantsearch-dom'

import NextIcon from '@/assets/icons/next.svg'
import PrevIcon from '@/assets/icons/prev.svg'

const Pagination = loadable(() =>
  import('react-instantsearch-dom').then((module) => ({
    default: module.Pagination
  }))
)

const CustumSeachPagination: React.FC<{ showFirst: boolean }> = ({ showFirst }) => {
  const translations = useMemo(
    () => ({
      previous: <img src={PrevIcon} alt="" aria-hidden="true" />,
      next: <img src={NextIcon} alt="" aria-hidden="true" />,
      first: '«',
      last: '»',
      page(currentRefinement: number) {
        return currentRefinement
      },
      ariaPrevious: 'Previous page',
      ariaNext: 'Next page',
      ariaFirst: 'First page',
      ariaLast: 'Last page',
      ariaPage(currentRefinement: number) {
        return `Page ${currentRefinement}`
      }
    }),
    []
  )

  return <Pagination showFirst={showFirst} translations={translations} />
}

export const CustomPagination = connectPagination(CustumSeachPagination)
